import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Drawer, Button } from 'antd';
import { QaError } from '../../types/QaErrors';
import { BugsTable } from './BugsTable';
import { ErrorInfo } from './ErrorInfo';
import { CreateBugButton } from './CreateBugButton';
import styles from './BugsModal.module.less';

type BugsModalProps = {
  scriptData: QaError;
  isModalOpen: boolean;
  hideModal: () => void;
};

export const BugsModal: React.FC<BugsModalProps> = ({ scriptData, isModalOpen, hideModal }) => {
  return (
    <Drawer placement="bottom" closable={false} onClose={hideModal} visible={isModalOpen} height={'100%'}>
      <Button onClick={hideModal} className={styles.closeBtn} type="link">
        <FontAwesomeIcon icon={['fal', 'times']} size={'3x'} />
      </Button>
      <div className={styles.root}>
        <h1 className={styles.title}>Bugs</h1>
        <ErrorInfo errorInfo={scriptData} />
        <CreateBugButton
          application={scriptData.applicationName}
          siteCode={scriptData.siteCode}
          className={styles.createBugBtn}
        />
        <div className={styles.content}>
          <BugsTable scriptData={scriptData} />
        </div>
      </div>
    </Drawer>
  );
};
